// MT — scripts propios de la tienda
if (!window.__mtScriptsInit) {
  window.__mtScriptsInit = true;
  document.addEventListener('DOMContentLoaded', function () {
    initMtReveal();
    initMtBarraMovil();
    initMtStock();
  });
}

function initMtStock() {
  var stockEl = document.querySelector('.mt-producto [data-mt-stock]');
  var datosEl = document.querySelector('.mt-producto [data-mt-inventario]');
  var idInput = document.querySelector('.mt-producto input.product-variant-id');
  if (!stockEl || !datosEl || !idInput) return;

  var prefijo = stockEl.dataset.prefijo;
  var sufijo = stockEl.dataset.sufijo;
  if (prefijo === undefined || sufijo === undefined) return;

  var inventario;
  try {
    inventario = JSON.parse(datosEl.textContent);
  } catch (e) {
    return;
  }

  var actualizar = function () {
    var variante = inventario.filter(function (v) {
      return String(v.id) === String(idInput.value);
    })[0];
    if (!variante || variante.gestionado !== 'shopify' || variante.cantidad <= 0) {
      stockEl.hidden = true;
      stockEl.textContent = '';
      return;
    }
    stockEl.hidden = false;
    stockEl.textContent = prefijo + ' ' + variante.cantidad + ' ' + sufijo;
  };

  actualizar();
  idInput.addEventListener('change', actualizar);
}

function initMtBarraMovil() {
  var barra = document.querySelector('[data-mt-barra-movil]');
  if (!barra) return;

  var submitReal = document.querySelector('.mt-producto .product-form__submit');
  var precioReal = document.querySelector('.mt-producto .price');
  var precioEspejo = barra.querySelector('[data-mt-barra-precio]');
  var boton = barra.querySelector('[data-mt-barra-boton]');

  if (boton && submitReal) {
    boton.addEventListener('click', function () {
      submitReal.click();
    });
  }

  if (precioReal && precioEspejo) {
    var leerPrecioVisible = function () {
      var enOferta = precioReal.classList.contains('price--on-sale');
      var nodo = enOferta
        ? precioReal.querySelector('.price__sale .price-item--sale')
        : precioReal.querySelector('.price__regular .price-item--regular');
      return nodo ? nodo.textContent.replace(/\s+/g, ' ').trim() : '';
    };
    var actualizarPrecio = function () {
      var texto = leerPrecioVisible();
      if (texto) precioEspejo.textContent = texto;
    };
    actualizarPrecio();
    new MutationObserver(actualizarPrecio).observe(precioReal, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  barra.classList.add('mt-barra-movil--visible');
}

function initMtReveal() {
  var items = document.querySelectorAll('.mt-reveal');
  if (!items.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    items.forEach(function (el) {
      el.classList.add('mt-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );

  items.forEach(function (el) {
    observer.observe(el);
  });
}
